import { observer } from "mobx-react-lite"
import React from "react"
import { MessageStatus } from "~proto"
import { useStores } from "../../models"
import styled from '~/ui/styled'
import MessageTime from "./message-time"
import StatusText from "./status-text"
import { prompt } from "~utils/prompt"

const Row = styled.View`
  flex-direction: row;
  align-items: center;
`

const ResendWrap = styled.Pressable``

const ResendText = styled.Text`
  color: ${({ theme }) => theme.colors.primary};
  margin-right: 5px;
`
interface Props {
  message_id: string
  time: Date
  color?: string
}

// 消息状态组件
const Status: React.FC<Props> = ({ color, time, message_id }) => {
  const { messageStore } = useStores()
  const message = messageStore.messages.get(message_id) || {}
  const { status, byMe } = message
  const resend = () => {
    message.setStatus(MessageStatus.SENDING)
    messageStore.sendMessageByMessageType(message)
  }
  const promptResend = () => {
    prompt({
      title: "点击重发",
      message: "确定要重发消息?",
      onSuccess: resend,
    })
  }
  return (
    <Row>
      {status === MessageStatus.FAILED && (
        <ResendWrap onClick={promptResend}>
          <ResendText>点击重发</ResendText>
        </ResendWrap>
      )}
      <MessageTime time={time} color={color} />
      {byMe ? <StatusText color={color} status={status} /> : null}
    </Row>
  )
}
export default observer(Status)
